<template>

</template>

<script>
import * as tools from '../tool'
export default {
  name: 'FirstBank',
  data () {
    return {
      active: 0,

      APIData: {
        txnType: '',
        content: ''

      },

      isIE: false,
      inputData: null
    }
  },

  created () {
    console.log('======created FirstBankView =====')
    this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1
    this.APIData.txnType = this.$route.query.txnType
    this.APIData.content = this.$route.query.content

    const vm = this

    this.$http
      .post('./WebApi/FirstBank/BankInfo/', vm.APIData)
      .then((response) => {
        if (!tools.isNull(response)) {
          //    tools.showAlert(vm.APIData, 'success', '銷帳成功' );

        }
      })
      .catch(function (error) {
        tools.showAlert(vm.APIData, 'danger', '網路連線失敗' + error)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
